import React from "react";
import MenuIcon from "@mui/icons-material/Menu";
import CloseIcon from "@mui/icons-material/Close";
import "./styles.css";
import "./HeaderModern.css";
import Button from "@mui/material/Button";
import { Link, useHistory } from "react-router-dom";
import Cookie from "js-cookie";
import { withRouter } from "react-router";
import HomeIcon from "@mui/icons-material/Home";
import LogoutIcon from "@mui/icons-material/Logout";
import SchoolIcon from "@mui/icons-material/School";
import commonData, { isAdmin } from "../importanValue";
import OneSignal from "react-onesignal";
import { useWebsite } from "../context/WebsiteContext";
import { getWebsiteConfig } from "../websiteConfig";

if (isAdmin()) {
  {
    OneSignal.sendTag("user", "admin");
  }
}

const Header = (props) => {
  const [menu, openMenu] = React.useState(false);
  const token = Cookie.get("jwt_token");
  const history = useHistory();
  const { websiteId } = useWebsite();
  const config = getWebsiteConfig(websiteId);
  // console.log(props);
  const logoutUser = (props) => {
    // const websiteId = localStorage.getItem('currentWebsiteId') || 'default';
    Cookie.remove("jwt_token");
    localStorage.removeItem("num");
    localStorage.removeItem("sessionId");
    localStorage.removeItem("uid");
    localStorage.removeItem("name");
    history.replace(`/${websiteId}/login`);
  };
  const phoneNum = localStorage.getItem("userDetailsApp");

  const isRajeshWebsite =true // websiteId === 'exams-with-rajesh';

  return (
    <>
      {/* Modern Header */}
      <header className={isRajeshWebsite ? "modern-header" : "header-container" + " header-desktop"}>
        {isRajeshWebsite ? (
          <>
            {/* Top Bar with Logo and Actions */}
            <div className="header-top-bar">
              <Link to={`/${websiteId}`} className="header-brand">
                <img
                  src={config.logo}
                  alt={config.name}
                  className="header-logo"
                />
                <div className="header-brand-text">
                  <h1 className="header-brand-title">{config.name}</h1>
                  {/* <p className="header-brand-subtitle">ఇక్కడ అన్ని రాష్ట్ర & కేంద్ర ఉద్యోగాల TET Dsc Groups Banking వంటి పోటీ పరీక్షలకు టెస్ట్  సిరీస్ లు - EAMCET IIT JEE NEET మొదలైన ఎంట్రన్స్ లకు ఆ స్థాయిలో నమూనా పరీక్ష లు నిర్హహించబడును</p> */}
                </div>
              </Link>

              {/* Desktop Navigation */}
              <nav className="header-nav-desktop">
                <Link to={`/${websiteId}`} className="nav-link">
                  <HomeIcon fontSize="small" />
                  <span>Home</span>
                </Link>
                {token && (
                  <button className="nav-link nav-link-button" onClick={logoutUser}>
                    <LogoutIcon fontSize="small" />
                    <span>Logout</span>
                  </button>
                )}
              </nav>

              {/* Mobile Menu Toggle */}
              <button className="header-menu-toggle" onClick={() => openMenu(!menu)}>
                {menu ? <CloseIcon fontSize="large" /> : <MenuIcon fontSize="large" />}
              </button>
            </div>

            {/* Mobile Menu Overlay */}
            {menu && (
              <div className="mobile-menu-overlay" onClick={() => openMenu(false)}>
                <div className="mobile-menu-content" onClick={(e) => e.stopPropagation()}>
                  <div className="mobile-menu-header">
                    <SchoolIcon style={{ fontSize: 32, color: "#38bdf8" }} />
                    <h3>Menu</h3>
                    <button className="mobile-menu-close" onClick={() => openMenu(false)}>
                      <CloseIcon />
                    </button>
                  </div>

                  <nav className="mobile-menu-nav">
                    {/* {isAdmin() && (
                      <a
                        href="https://books.navachaitanya.net/orders"
                        target="_blank"
                        rel="noreferrer"
                        className="mobile-menu-link"
                      >
                        <span>View Book Orders List</span>
                      </a>
                    )} */}

                    {commonData.userMenu.map((eachMen) => {
                      return eachMen.enabled ? (
                        <Link
                          key={eachMen.url}
                          to={`/${websiteId}${eachMen.url}`}
                          className="mobile-menu-link"
                          target={eachMen.openInNewTab ? "_blank" : ""}
                          onClick={() => openMenu(false)}
                        >
                          <span>{eachMen.name}</span>
                        </Link>
                      ) : null;
                    })}

                    {isAdmin() && (
                      <>
                        {commonData.AdminMenu.map((eachMen) => {
                          return eachMen.enabled ? (
                            <Link
                              key={eachMen.url}
                              to={`/${websiteId}${eachMen.url}`}
                              className="mobile-menu-link admin-link"
                              onClick={() => openMenu(false)}
                            >
                              <span>{eachMen.name}</span>
                            </Link>
                          ) : null;
                        })}
                      </>
                    )}

                    <div className="mobile-menu-divider"></div>

                    <a
                      href="/privacy-policy.html"
                      target="_blank"
                      rel="noreferrer"
                      className="mobile-menu-link secondary-link"
                    >
                      <span>Privacy Policy</span>
                    </a>
                    <a
                      href="/terms-and-conditions.html"
                      target="_blank"
                      rel="noreferrer"
                      className="mobile-menu-link secondary-link"
                    >
                      <span>Terms and Conditions</span>
                    </a>
                    <a
                      href="/refund-policy.html"
                      target="_blank"
                      rel="noreferrer"
                      className="mobile-menu-link secondary-link"
                    >
                      <span>Refund Policy</span>
                    </a>

                    {token && (
                      <>
                        <div className="mobile-menu-divider"></div>
                        <button className="mobile-menu-link logout-link" onClick={logoutUser}>
                          <LogoutIcon fontSize="small" />
                          <span>Logout</span>
                        </button>
                      </>
                    )}
                  </nav>
                </div>
              </div>
            )}
          </>
        ) : (
          <>
            {/* Original Header for Other Websites */}
            <div className="header-logo-container">
              <Link to={`/${websiteId}`} style={{ display: 'flex', alignItems: 'center', textDecoration: 'none' }}>
                <img
                  src={config.logo}
                  alt={config.name}
                  className="header-logo-img"
                />
                <div style={{ marginLeft: '12px' }}>
                  <h1 style={{ margin: 0, fontSize: '20px', fontWeight: 700, color: '#fff' }}>{config.name}</h1>
                  <p style={{ margin: 0, fontSize: '13px', color: '#94a3b8' }}>{config.fullName}</p>
                </div>
              </Link>
            </div>
            <nav className="navbar">
              <div className="nav-buttons">
                <div className="nav-actions">
                  <Link to={`/${websiteId}`} className="linkto home-link">
                    <HomeIcon
                      className="home-button"
                      style={{ color: "orange", fontSize: "28px" }}
                    />
                  </Link>

                  {token !== undefined && <></>}
                </div>

                <div className="nav-menu-toggle">
                  <MenuIcon
                    className="mobile-icon"
                    fontSize="large"
                    onClick={() => openMenu(!menu)}
                    style={{ cursor: "pointer" }}
                  />
                </div>
              </div>
              {/* <div
                className="download-banner"
                style={{
                  display: phoneNum ? "none" : "block",
                }}
              >
                <a
                  href="https://play.google.com/store/apps/details?id=com.navachaitanya.onlineexams&hl=te&gl=US"
                  target="_blank"
                  rel="noopener noreferrer"
                  className="download-banner-link"
                >
                  NavaCHAITANYA Exams APP ను డౌన్లోడ్ చేయడానికి ఇక్కడ క్లిక్ చేయండి
                </a>
              </div> */}

              {menu && (
                <div className="mobile-menu-dropdown">
                  {/* {isAdmin() && (
                    <a
                      href="https://books.navachaitanya.net/orders"
                      target="_blank"
                      rel="noreferrer"
                      className="linkto"
                    >
                      <Button variant="contained" className="btn header-btns">
                        View Book Orders List
                      </Button>
                    </a>
                  )} */}
                  {commonData.userMenu.map((eachMen) => {
                    return eachMen.enabled ? (
                      <Link
                        key={eachMen.url}
                        to={`/${websiteId}${eachMen.url}`}
                        className="linkto"
                        target={eachMen.openInNewTab ? "_blank" : ""}
                        onClick={() => openMenu(false)}
                      >
                        <Button variant="contained" className="btn header-btns">
                          {eachMen.name}
                        </Button>
                      </Link>
                    ) : null;
                  })}

                  {isAdmin() && (
                    <>
                      {commonData.AdminMenu.map((eachMen) => {
                        return eachMen.enabled ? (
                          <Link
                            key={eachMen.url}
                            to={`/${websiteId}${eachMen.url}`}
                            className="linkto"
                            onClick={() => openMenu(false)}
                          >
                            <Button variant="contained" className="btn header-btns admin-btn">
                              {eachMen.name}
                            </Button>
                          </Link>
                        ) : null;
                      })}
                    </>
                  )}
                  <a
                    href="/privacy-policy.html"
                    target="_blank"
                    rel="noreferrer"
                    className="linkto"
                  >
                    <Button variant="contained" className="btn header-btns secondary-btn">
                      Privacy Policy{" "}
                    </Button>
                  </a>
                  <a
                    href="/terms-and-conditions.html"
                    target="_blank"
                    rel="noreferrer"
                    className="linkto"
                  >
                    <Button variant="contained" className="btn header-btns secondary-btn">
                      Terms and Conditions
                    </Button>
                  </a>
                  <a
                    href="/refund-policy.html"
                    target="_blank"
                    rel="noreferrer"
                    className="linkto"
                  >
                    <Button variant="contained" className="btn header-btns secondary-btn">
                      Refund Policy{" "}
                    </Button>
                  </a>
                  {token && (
                    <Button
                      variant="contained"
                      className="btn header-btns logout-btn"
                      onClick={logoutUser}
                    >
                      Logout
                    </Button>
                  )}
                </div>
              )}
            </nav>
          </>
        )}
      </header>
       </>
  );
};

export default withRouter(Header);
 
  
